import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy
} from "@angular/core";
import { SharedService } from "../../../../component/shared/shared.service";
import { AppointmentService } from "../../../appointment/service/appointment.service";
import { ActivatedRoute } from "@angular/router";
import { ClinicalNotesService } from "../../service/clinical-notes.service";
import { Patient } from "../../model/patient";
import { ClinicalNotes, ClinicalReport } from "../../model/clinical-notes";
import { Appointment } from "../../../appointment/model/appointment";
import { PatientService } from "../../service/patient-service.service";
import {
  DialogAction,
  ActionMessage
} from "../../../../shared/enum/dialog-action.enum";
import { DiagnoseService } from "../../../master/services/diagnose.service";
import { InvestigationService } from "../../../master/services/investigation.service";
import { ObservationService } from "../../../master/services/observation.service";
import { ComplaintService } from "../../../master/services/complaint.service";
import { NoteService } from "../../../master/services/note.service";
import { DrugServiceService } from "../../../master/services/drug-service.service";
import { Complaint } from "../../../master/model/complaint";
import { Investigation } from "../../../master/model/investigation";
import { Observation } from "../../../master/model/observation";
import { Diagnoses } from "../../../master/model/diagnoses";
import { Notes } from "../../../master/model/notes";
import { Drug } from "../../../master/model/drug";
@Component({
  selector: "app-clinical-notes",
  templateUrl: "./clinical-notes.component.html",
  styleUrls: ["./clinical-notes.component.css"]
})
export class ClinicalNotesComponent implements OnInit {
  @Input() patient: Patient;
  isAdd = false;
  isEdit = false;
  isErrorMessage = false;
  isSuccessMessage = false;
  isMasterAdd: boolean = false;
  selectedOption: string = "CMP";
  masterText = "";
  patientInfo: Patient;
  Aloading = false;
  message: string;
  drugStrength = "";
  drugNote: string = "";
  appointments: Appointment[];
  selectedAppointment: Appointment;
  appdata: number = null;
  clinicalData: ClinicalNotes;
  clinicalNotesList: ClinicalNotes[];
  complaints: any[];
  observations: any[];
  investigations: any[];
  diagnoses: any[];
  notes: any[];
  drugs: any[];
  complainList: any[];
  observationList: any[];
  investigationList: any[];
  diagnoseList: any[];
  notesList: any[];
  drugsList: any[];
  files: any[];
  filesData: any[];
  clinicalReport: any;
  removedFiles: any[];
  searchOption = "";
  user: any;
  appId = 0;
  constructor(
    private _sharedService: SharedService,
    private _usrService: PatientService,
    private _clncSrv: ClinicalNotesService,
    private _obsSrv: ObservationService,
    private _invSrv: InvestigationService,
    private _cmpSrv: ComplaintService,
    private _digSrv: DiagnoseService,
    private _noteSrv: NoteService,
    private _drugSrv: DrugServiceService,
    private route: ActivatedRoute
  ) {
    // this.clinicalData = new ClinicalNotes(null, this.patient.PatientId, '', '', '', '', '', this.selectedAppointment.AppointmentId, '','','');
    _sharedService.yesEmitted$.subscribe(text => {
      if (
        text.Action === DialogAction.DELETE.toString() &&
        text.Page === "CLINICALNOTES"
      ) {
        this.deleteClinicalNotes(text.Data);
      }
    });
    _sharedService.diagnosisAction$.subscribe(text => {
      this.ngOnInit();
    });
    this._usrService.text$.subscribe(data => {
      this.appointments = data.filter(
        x =>
          x.AppointmentIsBooked == true &&
          x.AppointmentIsCancelled == false &&
          x.IsComplete == 1 &&
          x.AppointmentIsCompleted == 1
      );
      if (this.appointments.length > 0) {
        this.selectedAppointment = this.appointments[0];
        this.appdata = this.appointments[0].AppointmentId;
      }
    });
  }

  getData(): ClinicalNotes[] {
    let comlainLen = 0;
    for (let i = this.complaints.length - 1; i >= 0; i--) {
      if (this.complaints[i].text === "") {
        this.complaints.splice(i, 1);
      } else {
        comlainLen = comlainLen + 1;
      }
    }
    let investigationLen = 0;
    for (let i = this.investigations.length - 1; i >= 0; i--) {
      if (this.investigations[i].text == "") {
        this.investigations.splice(i, 1);
      } else {
        investigationLen = investigationLen + 1;
      }
    }
    let diagnoseLen = 0;
    for (let i = this.diagnoses.length - 1; i >= 0; i--) {
      if (this.diagnoses[i].text == "") {
        this.diagnoses.splice(i, 1);
      } else {
        diagnoseLen = diagnoseLen + 1;
      }
    }
    let noteLen = 0;
    for (let i = this.notes.length - 1; i >= 0; i--) {
      if (this.notes[i].text == "") {
        this.notes.splice(i, 1);
      } else {
        noteLen = noteLen + 1;
      }
    }
    let obserLen = 0;
    for (let i = this.observations.length - 1; i >= 0; i--) {
      if (this.observations[i].text == "") {
        this.observations.splice(i, 1);
      } else {
        obserLen = obserLen + 1;
      }
    }
    let drugLen = 0;
    for (let i = this.drugs.length - 1; i >= 0; i--) {
      if (this.drugs[i].text == "") {
        this.drugs.splice(i, 1);
      } else {
        drugLen = drugLen + 1;
      }
    }

    let maxLen = 0;
    if (comlainLen > maxLen) {
      maxLen = comlainLen;
    }
    if (investigationLen > maxLen) {
      maxLen = investigationLen;
    }
    if (diagnoseLen > maxLen) {
      maxLen = diagnoseLen;
    }
    if (noteLen > maxLen) {
      maxLen = noteLen;
    }
    if (obserLen > maxLen) {
      maxLen = obserLen;
    }
    if (drugLen > maxLen) {
      maxLen = drugLen;
    }
    let appId = 0;
    let appDate = "";
    let appTime = "";
    if (this.appdata !== null) {
      appId = parseInt(this.appdata.toString());
      let appDataObj = this.appointments.filter(function(usr) {
        return usr.AppointmentId === appId;
      });
      const xDate = appDataObj[0].AppointmentDay;
      appDate =
        xDate.split("/")[2] +
        "/" +
        xDate.split("/")[1] +
        "/" +
        xDate.split("/")[0];
      appTime = appDataObj[0].AppointmentTime;
    } else {
      const appDate = "2001/01/01";
      const appTime = "00:00 AM";
    }

    let data: ClinicalNotes[] = [];
    for (let i = 0; i < maxLen; i++) {
      let complaint = "";
      if (this.complaints.length >= i + 1) {
        complaint = this.complaints[i].text;
      }
      let observation = "";
      if (this.observations.length >= i + 1) {
        observation = this.observations[i].text;
      }
      let investigation = "";
      if (this.investigations.length >= i + 1) {
        investigation = this.investigations[i].text;
      }
      let note = "";
      if (this.notes.length >= i + 1) {
        note = this.notes[i].text;
      }
      let diagnose = "";
      if (this.diagnoses.length >= i + 1) {
        diagnose = this.diagnoses[i].text;
      }
      let drug = "";
      if (this.drugs.length >= i + 1) {
        drug = this.drugs[i].text;
      }

      this.clinicalData = new ClinicalNotes(
        null,
        this.patient.PatientId,
        complaint,
        observation,
        investigation,
        diagnose,
        note,
        drug,
        appId,
        "",
        appDate,
        appTime
      );
      data.push(this.clinicalData);
    }

    return data;
  }
  extractDataFromClinicalNotes(data: any[], filter: string): any[] {
    const returnData = data.filter(function(dt) {
      return dt[filter] !== "" && dt[filter] !== null;
    });
    return returnData;
  }
  onChange(event: EventTarget, index: number) {
    const eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    const target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    const files: FileList = target.files;
    this.files[index].file = files[0];
    this.files[index].text = files[0].name;
  }
  addClinicalNotes() {
    this._clncSrv.data = this.getData();
    if (this._clncSrv.data.length > 0) {
      this._clncSrv.saveClinicalNotes().subscribe(
        data => {
          this.message = "Clinical saved successfully";
          this.isSuccessMessage = true;
          this.Aloading = false;
          this.hideMessage();
          this.cancelOperation();
          this.getClinicalNotes();
        },
        error => {
          this.message = error.data;
          this.isErrorMessage = true;
          this.Aloading = false;
          this.hideMessage();
        }
      );
    }

    if (this.files.length > 0) {
      let appId = 0;
      let appDate = "";
      let appTime = "";
      if (this.appdata !== null) {
        appId = parseInt(this.appdata.toString());
        let appDataObj = this.appointments.filter(function(usr) {
          return usr.AppointmentId === appId;
        });
        const xDate = appDataObj[0].AppointmentDay;
        appDate =
          xDate.split("/")[2] +
          "/" +
          xDate.split("/")[1] +
          "/" +
          xDate.split("/")[0];
        //appDate = appDataObj[0].AppointmentDay;
        appTime = appDataObj[0].AppointmentTime;
      } else {
        const appDate = "2001/01/01";
        const appTime = "00:00 AM";
      }
      this.filesData = [];
      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i].file !== null) {
          this.filesData.push(this.files[i].file);
        }
      }
      this.clinicalReport = new ClinicalReport(
        null,
        appId,
        this.patient.PatientId.toString(),
        "",
        "",
        appDate,
        appTime
      );
      this._clncSrv.reportData = this.clinicalReport;
      this._clncSrv.reportFiles = this.filesData;
      this._clncSrv.saveClinicalNotesReport().subscribe(
        data => {
          this.message = "Clinical Report saved successfully";
          this.isSuccessMessage = true;
          this.Aloading = false;

          this.hideMessage();
          this.cancelOperation();
          this.getClinicalNotes();
        },
        error => {
          this.message = error.data;
          this.isErrorMessage = true;
          this.Aloading = false;
          this.hideMessage();
        }
      );
    }
  }
  updateClinicalNotes() {
    this._clncSrv.data = this.getData();
    if (this._clncSrv.data.length > 0) {
      this._clncSrv.updateClinicalNotes().subscribe(
        data => {
          this.message = "Clinical saved successfully";
          this.isSuccessMessage = true;
          this.Aloading = false;
          this.hideMessage();
          this.cancelOperation();
          this.getClinicalNotes();
        },
        error => {
          this.message = error.data;
          this.isErrorMessage = true;
          this.Aloading = false;
          this.hideMessage();
        }
      );
    }
    if (this.removedFiles !== undefined) {
      if (this.removedFiles.length > 0) {
        for (const item of this.removedFiles) {
          this._clncSrv
            .deleteClinicalNotesReport(
              item.reportId,
              this.patient.PatientId,
              item.text
            )
            .subscribe(
              data => {},
              error => {
                this.Aloading = false;
              }
            );
        }
      }
    }
    if (this.files !== undefined) {
      if (this.files.length > 0) {
        let appId = 0;
        let appDate = "";
        let appTime = "";
        if (this.appdata !== null) {
          appId = parseInt(this.appdata.toString());
          let appDataObj = this.appointments.filter(function(usr) {
            return usr.AppointmentId === appId;
          });
          // appDate = appDataObj[0].AppointmentDay;
          const xDate = appDataObj[0].AppointmentDay;
          appDate =
            xDate.split("/")[2] +
            "/" +
            xDate.split("/")[1] +
            "/" +
            xDate.split("/")[0];
          appTime = appDataObj[0].AppointmentTime;
        } else {
          const appDate = "2001/01/01";
          const appTime = "00:00 AM";
        }
        this.filesData = [];
        for (let i = 0; i < this.files.length; i++) {
          if (this.files[i].file !== null) {
            this.filesData.push(this.files[i].file);
          }
        }
        this.clinicalReport = new ClinicalReport(
          null,
          appId,
          this.patient.PatientId.toString(),
          "",
          "",
          appDate,
          appTime
        );
        this._clncSrv.reportData = this.clinicalReport;
        this._clncSrv.reportFiles = this.filesData;
        this._clncSrv.saveClinicalNotesReport().subscribe(
          data => {
            this.message = "Clinical Report saved successfully";
            this.isSuccessMessage = true;
            this.Aloading = false;

            this.hideMessage();
            this.cancelOperation();
            this.getClinicalNotes();
          },
          error => {
            this.message = error.data;
            this.isErrorMessage = true;
            this.Aloading = false;
            this.hideMessage();
          }
        );
      }
    }
  }
  saveClinicalNotes(): void {
    this.Aloading = true;
    if (this.isAdd) {
      this.addClinicalNotes();
    }
    if (this.isEdit) {
      this.updateClinicalNotes();
    }
  }

  cancelOperation(): void {
    this.isAdd = false;
    this.complaints = [];
    this.investigations = [];
    this.observations = [];
    this.notes = [];
    this.drugs = [];
    this.diagnoses = [];
    this.files = [];
    this.files.push({ text: "", file: null, reportId: null });
    this.filesData = [];
    this.removedFiles = [];
    this.isEdit = false;
  }
  deleteClinicalData(data: ClinicalNotes) {
    //this.clinicalData = data;
    this._sharedService.emitDialog(
      true,
      "Delete",
      ActionMessage.DELETE.toString(),
      true,
      DialogAction.DELETE.toString(),
      "CLINICALNOTES",
      { notes: data, patient: this.patient.PatientId }
    );
  }
  deleteClinicalNotes(clinicalData: any) {
    this._clncSrv
      .deleteClinicalNotes(clinicalData.notes, clinicalData.patient)
      .subscribe(
        data => {
          this.message = "Clinical notes delete successfully";
          this.isSuccessMessage = true;
          this.Aloading = false;
          this.hideMessage();
          this.cancelOperation();
          this.getClinicalNotes();
        },
        error => {
          this.message = error.data;
          this.isErrorMessage = true;
          this.Aloading = false;
          this.hideMessage();
        }
      );
  }
  editClinicalData(vitalobj: any) {
    this.isEdit = true;
    this.complaints = [];
    this.investigations = [];
    this.observations = [];
    this.notes = [];
    this.drugs = [];
    this.diagnoses = [];
    this.removedFiles = [];

    // this.clinicalData = vitalobj);
    for (const item of vitalobj.ClinicalNotesDeatail) {
      if (item.ChiefComplaint != "") {
        this.complaints.push({ text: item.ChiefComplaint });
      }
      if (item.Diagnoses != "") {
        this.diagnoses.push({ text: item.Diagnoses });
      }
      if (item.Notes != "") {
        this.notes.push({ text: item.Notes });
      }
      if (item.Observation != "") {
        this.observations.push({ text: item.Observation });
      }
      if (item.Drugs != "") {
        this.drugs.push({ text: item.Drugs });
      }
      if (item.Investigation != "") {
        this.investigations.push({ text: item.Investigation });
      }
    }
    if (this.complaints.length == 0) {
      this.complaints.push({ text: "" });
    }
    if (this.diagnoses.length == 0) {
      this.diagnoses.push({ text: "" });
    }
    if (this.notes.length == 0) {
      this.notes.push({ text: "" });
    }
    if (this.observations.length == 0) {
      this.observations.push({ text: "" });
    }
    if (this.drugs.length == 0) {
      this.drugs.push({ text: "" });
    }
    if (this.investigations.length == 0) {
      this.investigations.push({ text: "" });
    }
    this.files = [];
    for (const item of vitalobj.ClinicalNotesReportDetail) {
      this.files.push({ text: item.FileName, file: null, reportId: item.Id });
    }
  }

  hideMessage(): void {
    setTimeout(() => {
      this.isErrorMessage = false;
      this.isSuccessMessage = false;
      this.message = "";
    }, 1000);
  }
  getObservation(): void {
    this.observationList = [];
    this._obsSrv.getObservations().subscribe(
      data => {
        this.observationList = data;
      },
      error => {}
    );
  }
  getNotes(): void {
    this.notesList = [];
    this._noteSrv.getNotes().subscribe(
      data => {
        this.notesList = data;
      },
      error => {}
    );
  }
  getDrugs(): void {
    this.drugsList = [];
    this._drugSrv.getDrugs().subscribe(
      data => {
        this.drugsList = data;
      },
      error => {}
    );
  }
  getInvestigation(): void {
    this.investigationList = [];
    this._invSrv.getInvestigations().subscribe(
      data => {
        this.investigationList = data;
      },
      error => {}
    );
  }
  getDiagnose(): void {
    this.diagnoseList = [];
    this._digSrv.getDiagnosess().subscribe(
      data => {
        this.diagnoseList = data;
      },
      error => {}
    );
  }
  getComplaints(): void {
    this.complainList = [];
    this._cmpSrv.getComplaints().subscribe(
      data => {
        this.complainList = data;
      },
      error => {}
    );
  }
  deleteNoteReport(reportId, fileName, obj: any[], ind: number): void {
    this.Aloading = true;
    this._clncSrv
      .deleteClinicalNotesReport(reportId, this.patient.PatientId, fileName)
      .subscribe(
        data => {
          this.message = "Report deleted successfully"!;
          obj.splice(ind, 1);
          this.Aloading = false;
          this.hideMessage();
        },
        error => {
          this.Aloading = false;
        }
      );
  }

  getClinicalNotes(): void {
    this.Aloading = true;
    this.clinicalNotesList = [];
    this._clncSrv.getClinicalNotes(this.patient.PatientId).subscribe(
      data => {
        this.clinicalNotesList = data;
        this.Aloading = false;
        this.hideMessage();
      },
      error => {
        this.Aloading = false;
      }
    );
  }
  setClinicalData() {
    this.observations = [];
    this.investigations = [];
    this.notes = [];
    this.complaints = [];
    this.diagnoses = [];
    this.files = [];
    this.drugs = [];
    this.files.push({ text: "", file: null });
    this.filesData = [];
    this.clinicalData = new ClinicalNotes(
      null,
      this.patient.PatientId,
      "",
      "",
      "",
      "",
      "",
      "",
      null,
      "",
      "",
      ""
    );
    this.observations.push({ text: "" });
    this.investigations.push({ text: "" });
    this.notes.push({ text: "" });
    this.complaints.push({ text: "" });
    this.diagnoses.push({ text: "" });
    this.drugs.push({ text: "" });
  }
  setData(text: string) {
    let count = 0;
    if (this.selectedOption === "CMP") {
      for (let i = this.complaints.length - 1; i >= 0; i--) {
        if (this.complaints[i].text === "") {
          this.complaints[i].text = text;
          count = count + 1;
          break;
        }
      }
      if (count === 0) {
        this.complaints.push({ text: text });
      }
    } else if (this.selectedOption === "ITG") {
      for (let i = this.investigations.length - 1; i >= 0; i--) {
        if (this.investigations[i].text == "") {
          this.investigations[i].text = text;
          count = count + 1;
          break;
        }
      }
      if (count === 0) {
        this.investigations.push({ text: text });
      }
    } else if (this.selectedOption === "OBT") {
      for (let i = this.observations.length - 1; i >= 0; i--) {
        if (this.observations[i].text == "") {
          this.observations[i].text = text;
          count = count + 1;
          break;
        }
      }
      if (count === 0) {
        this.observations.push({ text: text });
      }
    } else if (this.selectedOption === "DGN") {
      for (let i = this.diagnoses.length - 1; i >= 0; i--) {
        if (this.diagnoses[i].text == "") {
          this.diagnoses[i].text = text;
          count = count + 1;
          break;
        }
      }
      if (count === 0) {
        this.diagnoses.push({ text: text });
      }
    } else if (this.selectedOption === "DRG") {
      for (let i = this.drugs.length - 1; i >= 0; i--) {
        if (this.drugs[i].text == "") {
          this.drugs[i].text = text;
          count = count + 1;
          break;
        }
      }
      if (count === 0) {
        this.drugs.push({ text: text });
      }
    } else {
      for (let i = this.notes.length - 1; i >= 0; i--) {
        if (this.notes[i].text == "") {
          this.notes[i].text = text;
          count = count + 1;
          break;
        }
      }
      if (count === 0) {
        this.notes.push({ text: text });
      }
    }
  }

  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    this.getClinicalNotes();
    this.selectedOption = "CMP";
    this.route.params.subscribe(params => {
      this.appId = +params["appid"];
    });
    //this.getNotes();
    //this.getInvestigation();
    //this.getObservation();
    //this.getComplaints();
    //this.getDiagnose();
    //this.getDrugs();
  }
  ngOnChanges() {
    this.getClinicalNotes();
    this.selectedOption = "CMP";
  }
  addComplaints() {
    this.complaints.push({ text: "" });
  }
  removeComplaints(index: number) {
    this.complaints.splice(index, 1);
  }
  addObservation() {
    this.observations.push({ text: "" });
  }
  removeObservation(index: number) {
    this.observations.splice(index, 1);
  }

  addInvestigation() {
    this.investigations.push({ text: "" });
  }
  removeInvestigation(index: number) {
    this.investigations.splice(index, 1);
  }
  addDiagnose() {
    this.diagnoses.push({ text: "" });
  }
  removeDiagnose(index: number) {
    this.diagnoses.splice(index, 1);
  }
  addNotes() {
    this.notes.push({ text: "" });
  }
  removeNotes(index: number) {
    this.notes.splice(index, 1);
  }
  addDrugs() {
    this.drugs.push({ text: "" });
  }
  removeDrugs(index: number) {
    this.drugs.splice(index, 1);
  }
  addFiles() {
    this.files.push({ text: "", file: null, reportId: null });
  }
  removeFiles(index: number, item: any) {
    if (item.reportId !== undefined && item.reportId !== null) {
      this.removedFiles.push(item);
    }
    this.files.splice(index, 1);
  }
  trackByIndex(index: number, value: number) {
    return index;
  }

  saveMaster() {
    this.Aloading = true;
    if (this.masterText == "") {
      this.isMasterAdd = false;
      this.Aloading = false;
      return;
    }
    if (this.selectedOption == "CMP") {
      this._cmpSrv.data = new Complaint(null, this.masterText);

      this._cmpSrv.saveComplaint().subscribe(
        data => {
          this.isMasterAdd = false;
          this.masterText = "";
          this.Aloading = false;
          this.getComplaints();
        },
        error => {
          this.isMasterAdd = false;
          this.Aloading = false;
        }
      );
    } else if (this.selectedOption == "ITG") {
      this._invSrv.data = new Investigation(null, this.masterText);
      this._invSrv.saveInvestigation().subscribe(
        data => {
          this.isMasterAdd = false;
          this.masterText = "";
          this.Aloading = false;
          this.getInvestigation();
        },
        error => {
          this.isMasterAdd = false;
          this.Aloading = false;
        }
      );
    } else if (this.selectedOption == "OBT") {
      this._obsSrv.data = new Observation(null, this.masterText);
      this._obsSrv.saveObservation().subscribe(
        data => {
          this.isMasterAdd = false;
          this.masterText = "";
          this.Aloading = false;
          this.getObservation();
        },
        error => {
          this.isMasterAdd = false;
          this.Aloading = false;
        }
      );
    } else if (this.selectedOption == "DGN") {
      this._digSrv.data = new Diagnoses(null, this.masterText);
      this._digSrv.saveDiagnoses().subscribe(
        data => {
          this.isMasterAdd = false;
          this.masterText = "";
          this.Aloading = false;
          this.getDiagnose();
        },
        error => {
          this.isMasterAdd = false;
          this.Aloading = false;
        }
      );
    } else if (this.selectedOption == "NOT") {
      this._noteSrv.data = new Notes(null, this.masterText, "", null);
      this._noteSrv.saveNotes().subscribe(
        data => {
          this.isMasterAdd = false;
          this.masterText = "";
          this.getNotes();
        },
        error => {
          this.isMasterAdd = false;
          this.Aloading = false;
        }
      );
    } else {
      this._drugSrv.data = new Drug(
        null,
        this.masterText,
        this.drugStrength,
        this.drugNote,
        "",
        "",
        0,
        0,
        "Oral"
      );
      this._drugSrv.saveDrug().subscribe(
        data => {
          this.isMasterAdd = false;
          this.masterText = "";
          this.drugStrength = "";
          this.drugNote = "";
          this.Aloading = false;
          this.getDrugs();
        },
        error => {
          this.isMasterAdd = false;
          this.drugStrength = "";
          this.drugNote = "";
          this.Aloading = false;
        }
      );
    }
  }

  showPrescription(cl): void {
    let patientData = this.patient;
    this._sharedService.overlay({
      module: "PATIENT",
      type: "Diagnosis",
      isShow: true,
      data: patientData,
      secondData: { appData: this.appointments, appId: cl.AppointmentId }
    });
  }

  showAppointment(appId: number) {
    window.open(
      "https://www.theaurapower.com/User/ExpertAdvice?AppointmentId=" + appId,
      "_blank",
      "width:100%"
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/section/patient/view-patient-profile/clinical-notes/clinical-notes.component.ts